import { call, put } from 'redux-saga/effects';
// COMMON
import { notification } from 'elements';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';
import { wsClient } from '@/index';

export function* getVisitsListSaga(action) {
	/**
	 * @param clientId
	 * @param siteId
	 * @param clientReference
	 */
	yield put({
		type: actionTypes.VISITS_START,
	});
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.visit.list-recent-visits',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.VISITS_LIST_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.VISITS_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/visits.js